export default {"src":"/_next/static/media/SETUP_GUIDE_SUCCESS.f206ef32.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};